<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Všetky moje vecičky na Valentínsky sviatok"
      header="♥VALENTÍN♥"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/valentin/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Valentin',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/velkanoc/velkanoc42.jpg','/static/images/velkanoc/velkanoc43.jpg'],
        title: "Veľkonočný zajačik - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...jednoduchá a milá veľkonočná pohľadnička s motívom zajačika na lúke, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte na biely pohľadnicový základ. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 4
      },
      {
        pictutes: ['/static/images/valentin/valentin1.jpg','/static/images/valentin/valentin2.jpg'],
        subtitle: "Pohľadnica",
        title: "Srdce domova - 5,40 €",
        details: "...otváracia pohľadnica vytvorená motívom zo servítky a technikou decoupage. Motív srdca je ručne vyrezaný, väčšie srdiečko s kvetinkami je nalepené v 3D efekte, na menšom (vnútornom) srdiečku je v 3D efekte nalepený domček. Pohľadnica je vytvorená vrstvením papierov. Vnútro a zadná strana bez textu, v bielej farbe. Ku pohľadnici posielam ručne robenú obálku.",
        size: "...rozmery sú cca 15 x 15 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 3
      },
      {
        pictutes: ['/static/images/valentin/valentin3.jpg','/static/images/valentin/valentin4.jpg','/static/images/valentin/valentin5.jpg'],
        title: "Magnetky láskyplné - 5,40 €",
        details: "...magnetky, ktoré boli vytvorené technikou decoupage, prelakované lakom na decoupage, na bielej zadnej papierovej strane s okrúhlym magnetom. ...cena za sadu 6 ks magnetiek",
        size: "cca 4,5 x 3,5 cm",
        material: "obyčajný papier, kartón, magnet",
        kind: "decoupage, lepenie",
        id: 2
      },
      {
        pictutes: ['/static/images/valentin/valentin6.jpg','/static/images/valentin/valentin7.jpg','/static/images/valentin/valentin8.jpg','/static/images/valentin/valentin9.jpg','/static/images/valentin/valentin10.jpg'],
        title: "Pohľadnica - 4,10 €",
        details: "...otváracia pohľadnica s kvetinovým motívom, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, dozdobené červenobielou šnúrkou a pečiatkou -z lásky-. Posielam s pevnou ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát",
        kind: "decoupage, cardmaking, lepenie",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Valentin.vue